import React from "react";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const DialNew = ({ setShowDial, handelDialPad, clear, setSetting }) => {
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00"];
  const numberArray = [10, 100, 200, 500];
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  return (
    <div>
      <div data-v-b1b92075 className="mb-2 flex">
        <div className="flex flex-1 justify-between">
          {(profileData?.stake?.length > 0
            ? profileData?.stake?.sort(function (a, b) {
                return a - b;
              })
            : numberArray
          )
            ?.slice(0, 4)
            ?.map((res) => {
              return (
                <button
                  className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-80px h-30px border-0"
                  type="button"
                  onClick={() => {
                    handelDialPad(res);
                  }}
                >
                  +{res}
                </button>
              );
            })}
          <button
            onClick={() => setSetting(true)}
            className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-9 h-30px border-0 text-16"
            type="button"
          >
            <i className="icon-setting" />
          </button>
        </div>
      </div>
      <div data-v-b1b92075 className="flex">
        <div className="flex flex-1 flex-wrap">
          {numberArrayCount?.map((res) => {
            return (
              <button
                className="w-2/12 h-40px flex justify-center items-center font-normal border border-white bg-black-100 rounded"
                type="button"
                onClick={() => handelDialPad(res)}
              >
                {res}
              </button>
            );
          })}

          <button
            onClick={() => {
              clear();
            }}
            className="icon-backspace w-2/12 h-40px flex justify-center items-center font-normal border border-white bg-black-100 rounded"
          />
        </div>
        <button
          onClick={() => setShowDial(false)}
          type="button"
          className="flex justify-center items-center w-20 text-base font-bold border-solid border-l border-white rounded bg-black-100"
        >
          {" "}
          OK{" "}
        </button>
      </div>
    </div>
  );
};

export default DialNew;
